import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Select,
  MenuItem,
  Tooltip,
  FormControl,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../../services/api";
import { cancelButton, saveButton } from "../../../../core/styles/ui.constants";
import BotonGenerico from "../../../../components/Button/Button";
import DialogFooter from "../../../../components/DialogFooter/DialogActions";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(4),
    width: "800px",
    maxHeight: "60vh",
    overflowY: "auto",
    overflowX: "auto",
  },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  titleText: {
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  tableContainer: {
    overflowX: "auto",
    marginBottom: theme.spacing(3),
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
    minWidth: "600px",
  },
  tableCell: {
    border: "none",
    textAlign: "center",
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      fontSize: "12px",
      padding: theme.spacing(0.5),
    },
  },
  actionButtons: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  actionButton: saveButton,
  cancelButton: cancelButton,
}));

const FormularioEvaluacionProveedor = ({
  open,
  onClose,
  onSuccess,
  evaluacionProveedor,
  editable,
}) => {
  const classes = useStyles();

  const [evaluacionDefault] = useState([
    { Criterio_de_evaluacion: "", valor: "" },
  ]);

  const [evaluacion, setEvaluacion] = useState(evaluacionDefault);
  const [errors, setErrors] = useState({});
  const [criterios, setCriterios] = useState([]);
  const [tieneOrden, setTieneOrden] = useState(false);

  const validarDatos = () => {
    const newErrors = {};

    evaluacion.forEach((item, index) => {
      if (!item.Criterio_de_evaluacion) {
        newErrors[`criterios_${index}`] =
          "Debe seleccionar un criterio de evaluación";
      }
      if (!item.valor) {
        newErrors[`valor_${index}`] =
          "Debe seleccionar un valor para este criterio";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInfoSubmit = () => {
    const validacion = validarDatos();
    if (!validacion) return;

    try {
      const nuevoEvaluacion = evaluacion.map((item) => ({
        Criterio_de_evaluacion: item.Criterio_de_evaluacion,
        valor: item.valor,
      }));

      onSuccess(nuevoEvaluacion);
      close();
    } catch (error) {
      console.error("Error al guardar el formulario:", error.message);
    }
  };

  const handleEvaluacionChange = (index, field, value) => {
    const newEvaluacion = [...evaluacion];
    newEvaluacion[index][field] = value;
    setEvaluacion(newEvaluacion);
  };

  const handleDeleteRow = (index) => {
    const newEval = evaluacion.filter((_, i) => i !== index);
    setEvaluacion(newEval);
  };

  const handleAddEvaluacion = () => {
    setEvaluacion([...evaluacion, { Criterio_de_evaluacion: "", valor: "" }]);
  };

  const close = () => {
    setEvaluacion([{ Criterio_de_evaluacion: "", valor: "" }]);
    setErrors({});
    setCriterios([]);
    onClose();
  };

  useEffect(() => {
    if (open) {
      const fetchData = async () => {
        const [criteriosResponse] = await Promise.all([api.criterios.getAll()]);

        const criterioMap = {};
        criteriosResponse.forEach((criterio) => {
          criterioMap[criterio.idcriterios_evaluacion] = criterio.Nombre;
        });

        setCriterios(criterioMap);

        const esVer = evaluacionProveedor.some((item) => item.idOrdenCompra);

        if (esVer) {
          const evaluacion = evaluacionProveedor.map((item) => ({
            Criterio_de_evaluacion: item.idCriterioEvaluacion,
            valor: item.valor,
          }));
          setEvaluacion(evaluacion);
          // setTieneOrden(true);
        } else {
          setEvaluacion([{ Criterio_de_evaluacion: "", valor: "" }]);
          // setTieneOrden(false);
        }

        setTieneOrden(esVer && !editable);
      };

      fetchData();
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="md"
      style={{ minWidth: "800px", maxHeight: "90vh", overflowY: "auto" }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h6" className={classes.titleText}>
          Formulario de Evaluación del Proveedor
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={close}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}
        >
          {!tieneOrden && editable && (
            <Tooltip
              title={
                <span style={{ fontSize: "0.8rem" }}>
                  {evaluacion.length >= Object.keys(criterios).length
                    ? "No hay más criterios a elegir"
                    : "Agregar otro criterio"}
                </span>
              }
              arrow
            >
              <span>
                <IconButton
                  color="primary"
                  onClick={handleAddEvaluacion}
                  size="small"
                  disabled={
                    evaluacion.length >= Object.keys(criterios).length &&
                    !editable
                  }
                >
                  <AddIcon />
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
        <Table style={{ tableLayout: "fixed", minWidth: "700px" }}>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ width: "40%" }}>
                Criterios de Evaluación
              </TableCell>
              <TableCell colSpan={5} align="center">
                <div
                  style={{ display: "flex", justifyContent: "center", gap: 50 }}
                >
                  {[1, 2, 3, 4, 5].map((num) => (
                    <div key={num}>{num}</div>
                  ))}
                </div>
              </TableCell>
              {!tieneOrden && (
                <TableCell align="center" style={{ width: "10%" }}>
                  Acciones
                </TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {evaluacion.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Select
                    variant="outlined"
                    fullWidth
                    value={item.Criterio_de_evaluacion || ""}
                    onChange={(e) =>
                      handleEvaluacionChange(
                        index,
                        "Criterio_de_evaluacion",
                        e.target.value
                      )
                    }
                    error={!!errors[`criterios_${index}`] || undefined}
                    disabled={tieneOrden}
                  >
                    {Object.keys(criterios)
                      .filter((key) => {
                        return !evaluacion.some(
                          (ev, i) =>
                            i !== index && ev.Criterio_de_evaluacion === key
                        );
                      })
                      .map((key) => (
                        <MenuItem key={key} value={key.toString()}>
                          {criterios[key]}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors[`criterios_${index}`] && (
                    <Typography color="error" variant="body2">
                      {errors[`criterios_${index}`]}
                    </Typography>
                  )}
                </TableCell>

                {/* Celda que contiene los 5 checkboxes y el error debajo */}
                <TableCell colSpan={5} align="center">
                  <FormControl
                    error={!!errors[`valor_${index}`]}
                    component="fieldset"
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 16,
                      }}
                    >
                      {[1, 2, 3, 4, 5].map((num) => (
                        <Checkbox
                          key={num}
                          checked={item.valor === num}
                          onChange={() =>
                            handleEvaluacionChange(index, "valor", num)
                          }
                          disabled={tieneOrden || !editable}
                        />
                      ))}
                    </div>
                    {errors[`valor_${index}`] && (
                      <Typography color="error" variant="body2">
                        {errors[`valor_${index}`]}
                      </Typography>
                    )}
                  </FormControl>
                </TableCell>

                {!tieneOrden && editable && (
                  <TableCell align="center">
                    <Tooltip
                      title={
                        <span style={{ fontSize: "0.8rem" }}>Eliminar</span>
                      }
                      arrow
                    >
                      <IconButton
                        color="secondary"
                        onClick={() => handleDeleteRow(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogFooter>
        {!tieneOrden && editable && (
          <BotonGenerico
            tipo={"guardar"}
            color="primary"
            onClick={handleInfoSubmit}
            text="Guardar"
          />
        )}
        <BotonGenerico
          color="secondary"
          onClick={close}
          text={!tieneOrden && editable ? "Cancelar" : "Cerrar"}
        />
      </DialogFooter>
    </Dialog>
  );
};

export default FormularioEvaluacionProveedor;
